import { useEffect, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.scss";
import "./interceptors/fpAdminApiInterceptor";
import "./interceptors/guestyApiInterceptor";
import "./services/authService";
import Layout from "./views/_Layout/Layout";
import Home1 from "./views/Home/Home1";
import { SearchProvider } from "./context/SearchContext";

const App = () => {
  const [uiLoaded, setUiLoaded] = useState(false);
  useEffect(() => {
    if (window.location.href.indexOf("/#/") > -1) {
      window.location.assign(window.location.href.replace("/#/", "/"));
    }

    const handleUIFullyLoaded = () => {
      setUiLoaded(true);
    };

    // Fires when ALL UI (images, css, fonts, bg img, scripts) are finished.
    window.addEventListener("load", handleUIFullyLoaded);

    return () => {
      window.removeEventListener("load", handleUIFullyLoaded);
    };
  }, []);

  if (!uiLoaded) {
    return <div className="loader" />;
  }

  return (
    <BrowserRouter>
      <Switch>
        <SearchProvider>
          <Route path="/" exact render={(props) => <Home1 {...props} />} />
          <Layout />
        </SearchProvider>
      </Switch>
    </BrowserRouter>
  );
};

export default App;
